import { render } from "./OrdersShowTable.vue?vue&type=template&id=bfee3cb8"
import script from "./OrdersShowTable.vue?vue&type=script&lang=js"
export * from "./OrdersShowTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__